import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/authentication/AuthContext";
import "./subscriptionOverlay.css";

const SubscriptionOverlay = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSupportWhatsApp = () => {
    const customerName = user?.owner || "Merchant";
    const message = `Hello CloudRasoi Support, my name is ${customerName}. I am experiencing an issue with my subscription (expired/required). Please assist me in renewing my plan.`;
    const whatsappUrl = `https://wa.me/918570996916?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="subscription-overlay">
      <div className="subscription-card">
        <h2>🚫 Subscription Expired</h2>

        <p>
          Your subscription has expired.
          <br />
          Please activate a plan to continue using CloudRasoi services.
        </p>

        <button onClick={() => navigate("/subscription-plans")}>
          View Plans & Activate
        </button>

        <button onClick={handleSupportWhatsApp} className="whatsapp-btn">
          💬 Chat on WhatsApp
        </button>

        <p className="support">
          Need help? Contact customer care.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionOverlay;